<ng-container [formGroup]="agentInfoForm">

    <!---tab1 -->
    <div #tabOneControls class="form-container">

        <div class="form-group">
            <label for="name">{{'FRONT_USER.FEES_ESTIMATION_FORM.AGENT_NAME' | translate}}</label>
            <input type="text" formControlName="name" class="form-control" />
        </div>

        <div class="form-group">
            <label for="Phone">{{'FRONT_USER.AGENT_REGISTRATION_FORM.PHONE1' | translate}}</label>
            <input type="text" formControlName="Phone1" class="form-control" />
        </div>

        <div class="form-group">
            <label for="currencyId">{{'FRONT_USER.FEES_ESTIMATION_FORM.PAYMENT_CURRENCY'| translate}}</label>
            <span class="red">*</span>
            <select (change)="ChangingCurrency($event)" formControlName="currencyId" class="form-control"
                id="currencyId" name="currencyId">
                <option [value]='null' selected>
                    {{'FRONT_USER.AGENT_REGISTRATION_FORM.CURRENCY_CHOOSE' | translate}}
                </option>
                <ng-container *ngFor="let currency of genericLookupModel">
                    <option *ngIf="displayedLang==Languages.English" [value]="currency.Id">
                        {{currency.NameEN}}
                    </option>
                    <option *ngIf="displayedLang==Languages.Arabic" [value]="currency.Id">
                        {{currency.NameAR}}
                    </option>
                </ng-container>

            </select>
            <div *ngIf="isTabOneSubmitted ||(f.currencyId?.dirty && f.currencyId?.errors || f.currencyId?.value=='null')"
                class="red ">
                <div *ngIf="f.currencyId?.errors?.required || f.currencyId?.value=='null' ">
                    {{'FRONT_USER.This_Field_Is_Required'| translate}}
                </div>
            </div>
        </div>

    </div>
    <p class="btns-holder text-right">
        <button type="button" class="btn SCAcustomBtn"
            (click)="selectTab(1) ">{{ 'FRONT_USER.NEXT' | translate}}</button>
    </p>
    <!---end tab1 -->

</ng-container>
